export const defCultureCookieName = "defCulture";
export const localePickerPath = "/games/locale";
export const defaultLocaleReturnPath = "/games/partner";
